export default "__VITE_ASSET__QaQXgaYy__"